module.exports = __webpack_public_path__ + "static/media/backgroupd.bfc1ca94.png";